"use client";

import React from "react";
import { Check, Mail, Phone, MapPin, Clock } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "No upfront costs",
  description: "Operating with honesty and transparency as faithful caretakers of your financial recovery journey."
}, {
  title: "Compassionate, client-first approach",
  description: "Our commitment to ethical service ensures every case is handled with professional and moral excellence."
}, {
  title: "Attorney partnerships to support claims",
  description: "We treat every individual with dignity and respect, understanding the weight of financial restoration."
}, {
  title: "Focused on Metro Atlanta and Georgia",
  description: "Expert focus on reclaiming unclaimed funds resulting from tax deed sales and foreclosures."
}, {
  title: "Clear, transparent process",
  description: "Enjoy clear communication at every step, ensuring you are always informed about the status of your claim."
}, {
  title: "Restoring What's Yours",
  description: "Guided by our mission to reunite you with your rightful assets and help regain financial stability."
}];
export default function FeatureAdvantage() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227622" id="whychooseus" className="bg-background text-foreground py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={headerReveal.ref} className={`max-w-3xl mx-auto text-center transition-all duration-700 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl font-bold tracking-tight !text-[hsl(224,76%,48%)] md:text-5xl">
            Why Choose RR Recovery Solution
          </h2>
          <p className="mt-6 text-lg md:text-xl text-muted-foreground font-default max-w-2xl mx-auto">Why Work With Roberts &amp; Roberts Recovery Solutions?</p>
        </div>

        <div ref={gridReveal.ref} className={`mt-20 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 transition-all duration-1000 ease-out delay-200 ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-background border-border rounded-lg shadow-sm flex flex-row items-start p-6 lg:p-8 gap-4 hover:border-primary/30 hover:shadow-md transition-all duration-300">
              <div className="shrink-0 mt-1">
                <Check className="w-6 h-6 text-primary" strokeWidth={2.5} />
              </div>
              <div className="space-y-2">
                <CardTitle className="font-default text-xl font-bold text-foreground">
                  {feature.title}
                </CardTitle>
                
              </div>
            </Card>)}

          
        </div>
      </div>
    </section>;
}